import { Box } from '@ltvco/refresh-lib/theme';
import * as React from 'react';

import { SearchInputField } from '../../shared/SearchForm';

export const SearchBarInput = (
  props: React.ComponentProps<typeof SearchInputField>
) => (
  <Box
    sx={{
      display: 'flex',
      flex: 1,
      minWidth: 0,
      width: '100%',
      '& input': {
        width: '100%',
        minWidth: 0,
      },
    }}
  >
    <SearchInputField {...props} />
  </Box>
);
